import { render, staticRenderFns } from "./AppletsContent.vue?vue&type=template&id=fc790138&scoped=true"
import script from "./AppletsContent.vue?vue&type=script&lang=js"
export * from "./AppletsContent.vue?vue&type=script&lang=js"
import style0 from "./AppletsContent.vue?vue&type=style&index=0&id=fc790138&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc790138",
  null
  
)

export default component.exports